import React from "react";
import classes from "./MapComponent.module.scss";
import ComponentTitleSection from "../../library/baaShared/ComponentTitleSection";

const MapComponent = ({ fields }) => {
  return (
    <div className={classes.mapContainer}>
      <ComponentTitleSection
        subtitle={ fields &&fields["Title"].value || "HOW TO FIND US"}
        title={
          fields && fields["Support Title"] && fields["Support Title"].value
        }
      />
      <div
        className={classes.mapImage}
        onClick={() => {
          window.open(
            "https://www.google.com/maps/place/Inside+Burj+Al+Arab/@25.1404455,55.1904664,15z/data=!4m5!3m4!1s0x0:0xeeced74c13ccad60!8m2!3d25.1404455!4d55.1904664",
            "_blank"
          );
        }}
      ></div>
    </div>
  );
};

export default MapComponent;
